import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import JsonMapper from "../helpers/JsonMapper";
var _attributes = /*#__PURE__*/new WeakMap();
export default class SubscriptionPlan extends JsonMapper {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [SubscriptionPlan.id_attribute_name]: null,
      [SubscriptionPlan.name_attribute_name]: null,
      [SubscriptionPlan.permissions_attribute_name]: [],
      [SubscriptionPlan.default_attribute_name]: 0,
      [SubscriptionPlan.normal_price_attribute_name]: 0,
      [SubscriptionPlan.sale_price_attribute_name]: 0,
      [SubscriptionPlan.nickname_attribute_name]: null
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return this.id_attribute_name;
  }
  static getNameAttributeName() {
    return this.name_attribute_name;
  }
  static getNicknameAttributeName() {
    return this.nickname_attribute_name;
  }
  static getSalePriceAttributeName() {
    return this.sale_price_attribute_name;
  }
  getId() {
    return this.getAttribute(SubscriptionPlan.getIdAttributeName());
  }
  getSalePrice() {
    var _this$getAttribute;
    return (_this$getAttribute = this.getAttribute(SubscriptionPlan.getSalePriceAttributeName())) !== null && _this$getAttribute !== void 0 ? _this$getAttribute : 0;
  }
  getName() {
    var _this$getAttribute2;
    return (_this$getAttribute2 = this.getAttribute(SubscriptionPlan.getNameAttributeName())) !== null && _this$getAttribute2 !== void 0 ? _this$getAttribute2 : SubscriptionPlan.BASIC_PLAN_NAME;
  }
  getNickname() {
    return this.getAttribute(SubscriptionPlan.getNicknameAttributeName());
  }
  getPermissions() {
    var _this$getAttribute3;
    return (_this$getAttribute3 = this.getAttribute(SubscriptionPlan.permissions_attribute_name)) !== null && _this$getAttribute3 !== void 0 ? _this$getAttribute3 : [];
  }
  isPermitted(permission) {
    if (!permission) return true;
    if (Array.isArray(permission)) {
      return this.isPermittedInEvery(permission);
    }
    return this.getPermissions().some(jsonPermission => new RegExp(`^${permission}`).test(jsonPermission));
  }
  isPermittedInEvery(permissions) {
    if (!Array.isArray(permissions)) {
      return this.isPermitted(permissions);
    }
    return permissions.every(permission => this.isPermitted(permission));
  }
  isSomePermitted(permission) {
    if (Array.isArray(permission) && !permission.length) return true;
    return this.isPermittedInSome(permission);
  }
  isPermittedInSome(permissions) {
    if (!Array.isArray(permissions)) {
      return this.isPermitted(permissions);
    }
    return permissions.some(permission => this.isPermitted(permission));
  }
  isBasicPlan() {
    return this.getName() === SubscriptionPlan.BASIC_PLAN_NAME;
  }
}
_defineProperty(SubscriptionPlan, "BASIC_PLAN_NAME", 'basic_plan');
_defineProperty(SubscriptionPlan, "ADVANCED_PLAN_NAME", 'advanced_plan');
_defineProperty(SubscriptionPlan, "BUSINESS_PLAN_NAME", 'business_plan');
_defineProperty(SubscriptionPlan, "FULL_ACCESS_PLAN_NAME", 'full_access_plan');
_defineProperty(SubscriptionPlan, "id_attribute_name", 'id');
_defineProperty(SubscriptionPlan, "name_attribute_name", 'name');
_defineProperty(SubscriptionPlan, "permissions_attribute_name", 'permissions');
_defineProperty(SubscriptionPlan, "default_attribute_name", 'default');
_defineProperty(SubscriptionPlan, "normal_price_attribute_name", 'normal_price');
_defineProperty(SubscriptionPlan, "sale_price_attribute_name", 'sale_price');
_defineProperty(SubscriptionPlan, "nickname_attribute_name", 'nickname');